<template>
    <div class="land-finefinish">
        <div class="container">
            <div class="land-section-title">
                <h2>{{salesCard.project_land_site.fine_finish_title}}</h2>
            </div>
            <div class="col-gallery">
                <div class="finefinish-gallery">
                    <swiper :options="swiperOption" ref="landLobbiGallery">
                        <swiper-slide v-for="(slide, index) in salesCard.project_land_site.fine_finish_gallery" :key="index">
                            <div class="promo-pic" :style="'background-image: url(' + slide + ')'"></div>
                        </swiper-slide>
                    </swiper>
                </div>
                <div class="swiper-controls sales-land-controls sales-land-finefinish-controls" v-if="salesCard.project_land_site.fine_finish_gallery != undefined && salesCard.project_land_site.fine_finish_gallery.length > 1">
                    <div class="container">
                        <div class="sales-land-btn-prev sales-land-finefinish-btn-prev slider-btn">
                            <svg-icon icon-class="left-arrow" className="icon icon-arrow-left"/>
                        </div>
                        <div class="sales-land-btn-next sales-land-finefinish-btn-next slider-btn">
                            <svg-icon icon-class="right-arrow" className="icon icon-arrow-right"/>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination sales-land-pagination sales-land-finefinish-pagination" v-if="salesCard.project_land_site.fine_finish_gallery != undefined && salesCard.project_land_site.fine_finish_gallery.length > 1"></div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-land-finefinish',
        components: {
        },
        data () {
            return {
                swiperOption: {
                    speed: 800,
                    loop: true,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    slidesPerView: 1,
                    simulateTouch: false,
                    watchSlidesVisibility: true,
                    lazy: {
                        loadPrevNext: true,
                        loadOnTransitionStart: true
                    },
                    autoplay: {
                        delay: 3500,
                        disableOnInteraction: true,
                    },
                    navigation: {
                        nextEl: '.sales-land-finefinish-btn-next',
                        prevEl: '.sales-land-finefinish-btn-prev',
                    },
                    pagination: {
                        el: '.sales-land-finefinish-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                },
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-finefinish.scss';
    @import '@/styles/respond/sales/sales-land-partials/land-finefinish-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>